import config from '../../config/config';
const { SEND_EMAIL_URL } = config;

export const sendOrderEmail = async ({
  orderId,
  total,
  formData,
}) => {
  try {
    const emailFormData = new FormData();

    emailFormData.append('ToEmail', 'mpabc8650@gmail.com');
    emailFormData.append('Subject', 'New Order Notification');
    emailFormData.append('EmailCode', '2');

    const emailBodyHTML = `
      <p style="font-weight: bold;">A new order has been placed with the following details:</p>
      <br>
      <p><b>Tracking Order ID:</b> ${orderId}</p>
      <p><b>Total Price:</b> Rs. ${total}</p>
      <p><b>Name:</b> ${formData.name}</p>
      <p><b>Mobile:</b> ${formData.mobile}</p>
      <p><b>Email:</b> ${formData.email}</p>
      <p><b>Pincode:</b> ${formData.pinCode}</p>
      <p><b>Address:</b> ${formData.address}</p>
      <p><b>City:</b> ${formData.city}</p>
      <p><b>State:</b> ${formData.state}</p>
    `;

    emailFormData.append('Body', emailBodyHTML);

    const emailResponse = await fetch(`${SEND_EMAIL_URL}SendEduTestMail`, {
      method: 'POST',
      body: emailFormData,
    });

    if (!emailResponse.ok) {
      console.error("Email sending failed");
    }

  } catch (err) {
    console.error("Email error:", err);
  }
};
